import { render, staticRenderFns } from "./TabletTeam.vue?vue&type=template&id=0279dd00&scoped=true&"
import script from "./TabletTeam.vue?vue&type=script&lang=js&"
export * from "./TabletTeam.vue?vue&type=script&lang=js&"
import style0 from "./TabletTeam.vue?vue&type=style&index=0&id=0279dd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279dd00",
  null
  
)

export default component.exports